import { INITIALIZE_FORM } from '../actionTypes';
import { creditFileActions } from '../reducer';

export default (values) => creditFileActions[INITIALIZE_FORM](values);
